import Header from "../Header";
import Navbar from "../Navbar";
import { useUser } from "@hooks/useUser";

type LayoutProps = {
  children: React.ReactNode;
};

function Layout({ children }: LayoutProps) {
  const { user } = useUser();

  if (!user) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <span>Loading...</span>
      </div>
    );
  }
  return (
    <div className="flex h-screen w-full">
      <Navbar />

      <div className="flex flex-col flex-1 min-w-0">
        <Header.Root>
          <Header.Menu />
          <Header.Breadcrumb />
          <Header.Profile
            name={user.username}
            avatarUrl={user.profilePictureUrl}
          />
        </Header.Root>

        <main className="flex-1 overflow-y-auto p-4 sm:p-6">{children}</main>
      </div>
    </div>
  );
}

export default Layout;
